import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import {Modal} from "peggirkit";
import {ContentLengthScore} from "./ContentLengthChecker";
import ScoreIndicator from "../../../../elements/scoreIndicator/ScoreIndicator";
import {globalModalStyling} from "../../../../elements/modal/modalStyle";

type Props = {
    result?: ContentLengthScore
};

const ContentLengthScoreIndicator = ({result}: Props) => {
    const intl = useIntl();
    const [showExplanation, setShowExplanation] = useState(false);

    if (!result) {
        return <>-</>;
    }

    return (
        <>
            <ScoreIndicator
                score={result.score}
                onClick={() => setShowExplanation(true)}
            />

            <Modal
                {...globalModalStyling(intl)}
                show={showExplanation}
                onClose={() => setShowExplanation(false)}
                title={intl.formatMessage({id: "contentLength"})}
            >
                <div className={"flex flex-col gap-6"}>
                    <p>
                        <FormattedMessage id="contentLength.description-1"/>
                    </p>
                    <p>
                        <FormattedMessage id="contentLength.description-2"/>
                    </p>
                    <p>
                        <FormattedMessage id="contentLength.description-3"/>
                    </p>
                    <p>
                        <FormattedMessage id="contentLength.description-4"/>
                    </p>
                    <p>
                        <FormattedMessage id="contentLength.description-5"/>
                    </p>
                    <p>
                        <span className={"text-black dark:text-white font-medium"}>
                            <FormattedMessage
                                id="contentLength.description-6"
                                values={{
                                    wordCount: result.wordCount,
                                }}
                            />
                        </span>
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default ContentLengthScoreIndicator;